import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8 * (props.wx ?? 1)}
    height={30 * (props.hx ?? 1)}
    viewBox="0 0 8 30"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.006 1.978c.014-.522.282-.747.746-.814C2.67 1.032 3.72 1 4.34 1c.62 0 1.473.032 2.39.164.463.067.732.292.745.814.045 1.792-.165 5.08-.338 6.415-.073.562-.193.99-.319 1.334-.227.618-.175 1.23-.268 1.83-.585 3.785-.479 10.704-.888 14.615-.229 2.187-.723 3.284-1.297 3.136-.538-.14-.778-1.368-1.007-3.547-.385-3.666-1.026-11.938-1.29-14.217-.078-.678-.212-1.212-.488-2.048a6 6 0 0 1-.235-1.102C1.17 7.059.96 3.77 1.006 1.979z"
    />
  </svg>
);
export default SvgNormal;
